import { Grid } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import MDButton from "components/MDButton";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { exportTAExceptional } from "services/data.outbound.service";
import { getTAExceptional } from "services/data.outbound.service";
import { LoadingDialog } from "ui-components/Alert";
import { TableCard } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
function Exception({ customerCode }) {
  const navigate = useNavigate();
  const columns = [
    {
      accessorKey: "custOrdNbr",
      header: "Cust Order Number",
      width: 200,
    },
    {
      accessorKey: "orderNumber",
      header: "Order Number",
      width: 200,
      cell: ({ row }) => {
        const { orderId, orderNumber } = row.original;
        return (
          <span
            style={{
              color: "#1A73E8",
              fontWeight: 400,
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => navigate("/outbound/so/edit", { state: {orderId,orderNumber,customerCode} })}
          >
            {orderNumber}
          </span>
        );
      },
    },
    {
      accessorKey: "orderDate",
      header: "Order Date",
      width: 200,
    },
    {
      accessorKey: "customerCode",
      header: "Customer Code",
      width: 200,
    },
    {
      accessorKey: "lineNo",
      header: "Line No",
      width: 100,
      align: "right",
    },
    {
      accessorKey: "skuCode",
      header: "SKU Code",
      width: 200,
    },
    {
      accessorKey: "orderQuantity",
      header: "Order Quantity",
      width: 150,
      align: "right",
    },
    { accessorKey: "shortQuantity", header: "Short Quantity", width: 150, align: "right" },
    {
      accessorKey: "createdBy",
      header: "Created By",
      width: 200,
    },
    {
      accessorKey: "createdOn",
      header: "Created On",
      width: 200,
    },
  ];
  const [list, setList] = useState([]);
  //const [loading, setLoading] = useState(null);
  const [type, setType] = useState("EXCEPTION");

  const { isFetching } = useQuery({
    queryKey: ["task-exceptional", { customerCode }],
    queryFn: () => getTAExceptional({ customerCode }),
    enabled: customerCode !== null,
    onSuccess: (data) => setList(data.data.data),
  });
  const exportMutation = useMutation(exportTAExceptional, {
    onSuccess: () => {
      //setLoading(null);
    },
  });
  const onExport = () => {
    //setLoading(<LoadingDialog />);
    exportMutation.mutate(
      { customerCode },
      {
        onSuccess: (data) => {
          const blob = new Blob([data.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${customerCode}_${type}.xlsx`);
          document.body.appendChild(link);
          link.click();
        },
      }
    );
  };
  const exportStatus = exportMutation.status === "loading";
  return (
    <>
      <TableCard sx={{ marginTop: 4 }}>
        {isFetching && <LoadingDialog />}
        {exportStatus && <LoadingDialog />}
        <Grid sx={{ padding: "10px" }} container spacing={3}>
          <Grid item>
            <MDButton
              color="info"
              variant="gradient"
              onClick={onExport}
              disabled={customerCode === null}
            >
              Export
            </MDButton>
          </Grid>
          {/* <Grid item>
            <FormControl>
              <RadioGroup
                row
                onChange={(e) => {
                  setType(e.target.value);
                }}
              >
                <FormControlLabel
                  labelPlacement="left"
                  value="EXCEPTION"
                  label="Preallocate Exception"
                  control={<Radio checked={type === "EXCEPTION"} />}
                />
                <FormControlLabel
                  labelPlacement="left"
                  value="FAILED"
                  label="Short Ship allocate"
                  control={<Radio checked={type === "FAILED"} />}
                />
              </RadioGroup>
            </FormControl>
          </Grid> */}
        </Grid>
        <BasicTable data={list} columns={columns} />
      </TableCard>
    </>
  );
}

export default Exception;
